import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as groupAction from './../../../../actions/groupAction';
import ProductReindex from './ProductReindex';

const mapStateToProps = state => {
  return {
    groupState: state.groupReducer,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    reindexProduct: (params) => dispatch(groupAction.reindexProductAction(params)),
  }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ProductReindex));
